import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CsvUpload } from '../../../models/csv-import.model';
import { CsvImportValidationComponent } from '../csv-import-validation-component/csv-import-validation.component';
import { KeyValue } from '@angular/common';
import { AlertService } from '../../../../core/alert.service';
import { CsvImportService } from '../../../services/csv-import.service';

@Component({
  selector: 'app-csv-column-mapping',
  templateUrl: './csv-column-mapping.component.html',
  styleUrls: ['./csv-column-mapping.component.scss'],
})
export class CsvColumnMappingComponent implements OnInit {
  @Input() csvData: any;
  @Input() type: string;

  public csvContent: string;
  public fileContent: string;
  public headerFromCSV: any[] = [];
  public selectedColumn: any[] = [];
  public headerFromDB: any[] = [];
  public mappingColumn: any = {};

  public myFormGroup: FormGroup;
  public form_template: any = [];
  public isRequired: boolean = true;
  public headerRowIndex: number;
  public firstRowData: any[];
  runningImports: number = 0;
  busy: boolean = false;
  isPaid: boolean = false;
  isSortedValue: any = false;

  constructor(
    private modalService: NgbActiveModal,
    private modalCSVService: NgbModal,
    private csvImportService: CsvImportService,
    private alert: AlertService
  ) {}

  ngOnInit() {
    // this.getInvoiceDBColumns();
    this.getImportColumns();
  }

  save(): void {
    this.onSubmit();
  }

  onSubmit() {
    if(this.myFormGroup.status === 'VALID') {
      this.busy = true;
      this.mappingColumn = this.cleanMappedColumn(this.myFormGroup.value);
      this.csvImportService
        .mapCsvDBColumns(
          this.mappingColumn,
          this.type ?? 'invoice',
          this.csvData.headerRowIndex,
          this.csvData.csvID
        )
        .subscribe(
          (res: any) => {
            if (res) {
              console.log(res);
              let csvUpload = new CsvUpload();
              csvUpload.UploadType = res.uploadtype;
              csvUpload.Items = res.Data;
              this.csvValidation(csvUpload);
              this.modalService.close();
            } else {
              this.alert.alertWarning({
                title: 'Column Mapping ',
                text: res.message,
              });
            }
          },
          (error: any) => {
            this.alert.alertWarning({
              title: 'Column Mapping ',
              text: 'Error Encountered: ' + error,
            });
          },
          () => {
            this.busy = false;
          }
        );
    }
  }

  csvValidation(res: any) {
    this.busy = true;
    let modal = this.modalCSVService.open(CsvImportValidationComponent, {
      size: 'xl',
      backdrop: 'static',
    });
    modal.componentInstance.itemsDataSource = res.Items;
    modal.componentInstance.uploadType = res.UploadType;
    modal.componentInstance.type = this.type ?? 'invoice';
    modal.result.then(
      (res) => {
        if (res.Code === 200 || res.code === 200) {
          this.runningImports = res.runningImports;
        } else {
          this.alert.alertWarning({ title: 'CSV Upload', text: res.message });
        }
      },
      (error: any) => {
        this.alert.alertWarning({
          title: 'CSV Upload',
          text: 'Error Encountered: ' + error,
        });
      }
    );
    this.busy = false;
  }

  cleanMappedColumn(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj;
  }

  getImportColumns(): void {
    this.busy = true;
    this.csvImportService.importColumns(this.type)
      .subscribe((res: any) => {
        if(res) {
          this.headerFromDB = res;
          this.csvContent = this.csvData.csvContent;
          this.headerFromCSV = Object.keys(this.csvContent[0]);
          this.generateMapPage(this.headerFromCSV);
        } else {
          this.alert.alertWarning({
            title: 'Column Mapping ',
            text: res.message,
          });
        }
      },
      (error: any) => {
        this.alert.alertWarning({
          title: 'Column Mapping ',
          text: 'Error Encountered: ' + error,
        });
      },
      () => {
        this.busy = false;
      }
      )
  }

  getInvoiceDBColumns() {
    this.busy = true;
    this.csvImportService.importInvoiceDBColumns().subscribe(
      (res: any) => {
        if (res) {
          this.headerFromDB = res;
          this.csvContent = this.csvData.csvContent;
          this.headerFromCSV = Object.keys(this.csvContent[0]); //get array of keys
          this.generateMapPage(this.headerFromCSV);
        } else {
          this.alert.alertWarning({
            title: 'Column Mapping ',
            text: res.message,
          });
        }
      },
      (error: any) => {
        this.alert.alertWarning({
          title: 'Column Mapping ',
          text: 'Error Encountered: ' + error,
        });
      },
      () => {
        this.busy = false;
      }
    );
  }

  // Dropdown selection
  public onOptionsSelected(event, formLabel) {
    let valueSelected = event.target.value; //index selected
    let indexSelected = [];
    let dataInput = this.selectedColumn.find((e) => e === valueSelected);

    if (dataInput && dataInput.length > 0) {
      this.alert.alertWarning({
        title: 'Column Mapping ',
        text: 'This column was previously selected.',
      });
    }
    if (formLabel == 'Paid') {
      this.isPaid = true;
      this.alert.alertWarning({
        title: 'Column Mapping ',
        text: '[DatePaid] or Date of Payment will be required for data with Paid amount.',
      });
    }

    indexSelected = Object.values(this.myFormGroup.value);
    this.selectedColumn = indexSelected;
    this.selectedColumn.push(valueSelected);
  }
  generateMapPage(headerFromCSV) {
    this.form_template = [];
    let index_value = 0;
    let selecetdIndex = '';
    selecetdIndex = String(index_value);
    for (let itemLabel of this.headerFromDB) {
      if (itemLabel.Name == 'DatePaid') {
        itemLabel.IsRequired = false;
      }
      this.form_template.push({
        type: 'select',
        name: selecetdIndex,
        label: itemLabel.Name,
        isRequired: itemLabel.Name === 'CustomerType' || itemLabel.Name === 'BusinessName' ? false :  itemLabel.IsRequired,
        dataType: itemLabel.DataType,
        maxLength: itemLabel.MaxLength,
        regexPattern: itemLabel.RegexPattern,
        options: headerFromCSV,
      });

      index_value++;
      selecetdIndex = String(index_value);
    }

    this.form_template.sort((a, b) =>
      a['isRequired'] < b['isRequired']
        ? 1
        : a['isRequired'] > b['isRequired']
        ? -1
        : 0
    );
    let group = {};
    this.form_template.forEach((input_template) => {
      group[input_template.name] = new FormControl('');
    });

    this.myFormGroup = new FormGroup(group);
  }

  close() {
    this.modalService.close();
  }

  sortTable(colName, sortedValue) {
    if (sortedValue == true) {
      this.form_template.sort((a, b) =>
        a[colName] < b[colName] ? 1 : a[colName] > b[colName] ? -1 : 0
      );
      this.isSortedValue = !this.isSortedValue;
    } else {
      this.form_template.sort((a, b) =>
        a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0
      );
      this.isSortedValue = !this.isSortedValue;
    }
  }

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };
}
